<template>
  <div class="order">
    <Detail />
    <van-empty v-if="fom.length == 0" description="暂无订单" />
    <div class="detail" v-for="item in fom" :key="item.id">
      <div
        style="
          font-size: 17px;
          font-weight: 700;
          padding: 15px;
          display: flex;
          justify-content: space-between;
        "
      >
        <span
          style="
            text-align: start;
            width: 80%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          "
        >
          {{ item.mealName }}
        </span>
        <span style="color: #009fff">{{ item.money }}元</span>
      </div>
      <van-collapse v-model="activeNames" style="padding: 0 10px">
        <van-collapse-item
          :border="false"
          style="text-align: left; border-top: 1px solid #c5e1ff"
          :title="'订单号:' + item.orderId"
          :name="item.id"
        >
          <div>
            <table
              style="
                width: 100%;
                border: 1px solid rgb(200, 200, 200);
                border-collapse: collapse;
              "
            >
              <tr>
                <td class="tds">卡号</td>
                <td class="td">{{ item.meCardNum }}</td>
              </tr>
              <tr>
                <td class="tds">套餐规格</td>
                <td class="td">
                  {{
                    item.imaginaryQuantity
                      ? Math.floor((item.imaginaryQuantity / 1024) * 100) / 100
                      : 0
                  }}G
                </td>
              </tr>
              <tr>
                <td class="tds">本月次月</td>
                <td class="td">
                  {{ item.monthType == 0 ? "本月" : "次月" }}
                </td>
              </tr>
              <tr>
                <td class="tds">套餐类型</td>
                <td class="td">{{ item.mealType }}</td>
              </tr>
              <tr>
                <td class="tds">有效期</td>
                <td class="td">{{ item.melaValidity }}</td>
              </tr>
              <tr>
                <td class="tds">支付方式</td>
                <td class="td">{{ item.payType }}</td>
              </tr>
              <tr>
                <td class="tds">充值时间</td>
                <td class="td">{{ item.payTime }}</td>
              </tr>
            </table>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
  </div>
</template>

<script>
  import { Loading } from "element-ui";
  import Detail from "@/components/Detail.vue";
  import { getPayTypeAll } from "@/api/newPay";
  import { phoneOrders } from "@/api/cardOperation";
  export default {
    data() {
      return {
        activeNames: ["1"],
        fom: [],
        //支付类型列表
        payTypeList: [],
      };
    },
    created() {},
    async mounted() {
      await this.getPayTypeAll();
      await this.phoneOrders();
      await Loading.service();
    },
    methods: {
      //支付类型
      getPayTypeAll() {
        getPayTypeAll().then((res) => {
          this.payTypeList = res.data;
        });
      },

      phoneOrders() {
        phoneOrders().then((res) => {
          if (res.status) {
            res.data.forEach((item) => {
              this.payTypeList.forEach((items) => {
                if (item.payType == items.payType) {
                  item.payType = items.payName;
                }
              });
              if (item.melaValidityType == 0) {
                item.melaValidity = item.melaValidity + "天";
              } else if (item.melaValidityType == 1) {
                item.melaValidity = item.melaValidity + "月";
              } else if (item.melaValidityType == 2) {
                item.melaValidity = item.melaValidity + "年";
              }

              if (item.mealType == "0") {
                item.mealType = "自然月套餐";
              } else if (item.mealType == "1") {
                item.mealType = "月卡套餐";
              } else if (item.mealType == "2") {
                item.mealType = "联通自然月套餐";
              } else if (item.mealType == "3") {
                item.mealType = "联通月卡套餐";
              } else if (item.mealType == "4") {
                item.mealType = "叠加包套餐";
              } else if (item.mealType == "5") {
                item.mealType = "无限叠加套餐";
              } else if (item.mealType == "6") {
                item.mealType = "基础套餐";
              }
            });
            this.fom = res.data;

            Loading.service().close();
          }
        });
      },
    },
    components: {
      Detail,
    },
  };
</script>

<style lang="scss" scoped>
  .tds {
    width: 30%;
    border: 1px solid rgb(190, 190, 190);
    border-right: 0;
    padding: 10px 10px;
  }
  .td {
    width: 70%;
    border: 1px solid rgb(190, 190, 190);
    padding: 10px 10px;
  }
  .order {
    // background-color: rgba(128, 128, 128, 0.1);
    padding: 15px;
    .detail {
      width: 100%;
      margin: 15px 0;
      border-radius: 10px;

      padding-bottom: 15px;
      box-sizing: border-box;
      border: 1px solid #c5e1ff;
    }
  }
</style>
